

import { useState , useEffect} from 'react';
import InnerNav from '../../../components/InnerNav/InnerNav';
import Zodiac from '../../../components/ZodiacSign/Zodiac';
import './Dainik.scss'
import Footer from '../../../components/Footer/Footer';
import axios from 'axios';
import city from '../../../city.json'



const Dainik = () => {

 const [monthly, setMonthly] = useState(null);
  const [currentDate, setCurrentDate] = useState(new Date());
  const [location, setLocation] = useState("Kolkata, India");
   const formattedDate = currentDate.toISOString().split("T")[0];

     const [timeFormat, setTimeFormat] = useState("12"); // "12", "24", or "24Plus"


       // Temporary states for user input for submit button and location dropdown
     const [tempDate, setTempDate] = useState(currentDate);
     const [tempLocation, setTempLocation] = useState("Kolkata");
     const [suggestions, setSuggestions] = useState([]);
 
useEffect(() => {
  const fetchMonthly = async () => {
     if (!location || location.trim() === '') return;
    try {
      // const currentdate = currentDate.toISOString().split('T')[0];
      const res = await axios.get(`https://core-c343.onrender.com/api/panchanga?date=${formattedDate}&location=${encodeURIComponent(location)}`);
      setMonthly(res.data);
      console.log('Fetching data for date:', formattedDate,'at' ,location);

    } catch (error) {
      console.error('Failed to fetch Panchang data', error);
    }
  };
  const debounce = setTimeout(fetchMonthly, 500); // Debounce API call by 500ms

  return () => clearTimeout(debounce); // Cleanup on unmount or input change

  // fetchMonthly();
}, [formattedDate, location]);


function convertUtcToIstTimeOnly(utcTimeStr, mode = '12') {
  if (!utcTimeStr) return 'N/A';

  const [time, modifier] = utcTimeStr.trim().split(' ');
  let [hours, minutes] = time.split(':').map(Number);

  if (modifier.toUpperCase() === 'PM' && hours !== 12) hours += 12;
  if (modifier.toUpperCase() === 'AM' && hours === 12) hours = 0;

  const today = new Date();
  const date = new Date(Date.UTC(today.getUTCFullYear(), today.getUTCMonth(), today.getUTCDate(), hours, minutes));

  const options = {
    timeZone: 'Asia/Kolkata',
    hour: '2-digit',
    minute: '2-digit',
    hour12: mode === '12',
  };

  return date.toLocaleTimeString('en-IN', options);
}



const formatTime = (timeStr, mode = "12") => {
  if (!timeStr || typeof timeStr !== "string" || timeStr.trim() === "") return "N/A";

  const parts = timeStr.split(":").map(Number);
  const hour = parts[0];
  const minute = parts[1];
  const second = parts[2];

  // If any required part is missing, return "N/A"
  if (isNaN(hour) || isNaN(minute) || (mode === "24+" && isNaN(second))) {
    return "N/A";
  }
  

  if (mode === "12") {
    const suffix = hour >= 12 ? "PM" : "AM";
    const hour12 = hour % 12 === 0 ? 12 : hour % 12;
    return `${hour12.toString().padStart(2, "0")}:${minute
      .toString()
      .padStart(2, "0")} ${suffix}`;
  }

  if (mode === "24") {
    return `${hour.toString().padStart(2, "0")}:${minute
      .toString()
      .padStart(2, "0")}`;
  }

  if (mode === "24+") {
    return `${hour.toString().padStart(2, "0")}:${minute
      .toString()
      .padStart(2, "0")}:${second.toString().padStart(2, "0")}`;
  }

  return timeStr;
};




const sunTable = monthly
  ? [
      { name: "Sunrise", info: formatTime(monthly.sunrise,timeFormat )},
      { name: "Sunset", info: formatTime(monthly.sunset, timeFormat) },
      { name: "Moonrise", info: formatTime(monthly.moonrise, timeFormat) },
      { name: "Moonset", info: formatTime(monthly.moonset, timeFormat )},

      
    ]
  : [];

const panchangLeft = monthly
  ? [
    { name: "Paksha", info: monthly.paksha },
      { name: "Maas", info: monthly.lunarMonth },
      
      {
        name: "Tithi",
        info: monthly.tithi?.name
          ? `${monthly.tithi.name} (${formatTime(monthly.tithi.start, timeFormat)} to ${formatTime(monthly.tithi.end, timeFormat)})`
          : "N/A",
      },
      {
        name: "Nakshatra",
        info: monthly.nakshatra?.name
          ? `${monthly.nakshatra.name} (${formatTime(monthly.nakshatra.start, timeFormat)} to ${formatTime(monthly.nakshatra.end, timeFormat)})`
          : "N/A",
      },
      {
        name: "Yoga",
        info: monthly.yoga?.name
          ? `${monthly.yoga.name} (${formatTime(monthly.yoga.start, timeFormat)} to ${formatTime(monthly.yoga.end, timeFormat)})`
          : "N/A",
      },
      {
        name: "Karana",
        info: Array.isArray(monthly.karana)
          ? monthly.karana
              .map(
                (k) =>
                  `${k.name} (${formatTime(k.end, timeFormat)})`
              )
              .join(", ")
          : "N/A",
      },
      {
        name: "Abhijit Muhurta",
        info: `${formatTime(monthly.muhurta?.abhijit?.start, timeFormat)} to ${formatTime(monthly.muhurta?.abhijit?.end, timeFormat)}`,
      },
      {
        name: "Yamaganda Kalam",
        info: `${formatTime(monthly.yamagandaKalam?.start, timeFormat)} to ${formatTime(monthly.yamagandaKalam?.end, timeFormat)}`,
      },
      {
        name: "Amrit Kalam",
        info: `${formatTime(monthly.amritKalam?.start, timeFormat)} to ${formatTime(monthly.amritKalam?.end, timeFormat)}`,
      },
    ]
  : [];


const panchangRight = monthly
  ? [
      { name: "Var", info: monthly.weekday },
      {
        name: "Rahu Kaal",
        info: `${formatTime(monthly.rahuKalam?.start, timeFormat)} to ${formatTime(monthly.rahuKalam?.end, timeFormat)}`,
      },
      {
        name: "Brahma Muhurta",
        info: `${formatTime(monthly.muhurta?.brahma?.start, timeFormat)} to ${formatTime(monthly.muhurta?.brahma?.end, timeFormat)}`,
      },
      {
        name: "Varjyam",
        info: `${formatTime(monthly.varjyam?.start, timeFormat)} to ${formatTime(monthly.varjyam?.end, timeFormat)}`,
      },
      {
        name: "Gulika Kalam",
        info: `${formatTime(monthly.gulikaKalam?.start, timeFormat)} to ${formatTime(monthly.gulikaKalam?.end, timeFormat)}`,
      },
      {
        name: "Durmuhurta",
        info: Array.isArray(monthly.durMuhurtas)
          ? monthly.durMuhurtas
              .map(
                (d) =>
                  `${formatTime(d.start, timeFormat)} to ${formatTime(d.end, timeFormat)}`
              )
              .join(", ")
          : "N/A",
      },
      {
        name: "Vikram Samvat",
        info: monthly.vikramSamvat?.formatted || "N/A",
      },
      {
        name: "Shaka Samvat",
        info: monthly.shakaSamvatDetails?.formatted || "N/A",
      },
      {
        name: "Gujarati Samvat",
        info: monthly.gujaratiSamvatDetails?.formatted || "N/A",
      },
    ]
  : [];





    const months = [
    "Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
  ];

  

    
  

      const handlePrevDay = () => {
    const prev = new Date(currentDate);
    prev.setDate(prev.getDate() - 1);
    setCurrentDate(prev);
  };

  const handleNextDay = () => {
    const next = new Date(currentDate);
    next.setDate(next.getDate() + 1);
    setCurrentDate(next);
  };

  const handleDateInput = (e) => {
    setTempDate(new Date(e.target.value));
  };

const handleMonthClick = (monthIndex) => {
  const newDate = new Date(tempDate);
  newDate.setMonth(monthIndex);
  setTempDate(newDate);
};

const handleDayClick = (day) => {
  const newDate = new Date(tempDate);
  newDate.setDate(day);
  setTempDate(newDate);
};

const handleSubmit = () => {
  setCurrentDate(tempDate);
  setLocation(tempLocation);
};


  const handleChange = (e) => {
    const value = e.target.value;
    setTempLocation(value);

    // filter cities when user types
    if (value.length > 0) {
      const filtered = city.filter((c) =>
        c.city.toLowerCase().includes(value.toLowerCase())
      );
      setSuggestions(filtered.slice(0, 4)); // show only first 4 results
    } else {
      setSuggestions([]);
    }
  };

  const handleSelect = (cityName) => {
    setTempLocation(cityName);
    setSuggestions([]);
  };


  
    const readableDate = `${months[currentDate.getMonth()]} ${currentDate.getDate()}, ${currentDate.getFullYear()}`;
    //const weekDay = currentDate.toLocaleDateString("en-US", { weekday: "long" });

  return(
    <div className="dainik-container">
      <InnerNav/>
      <div className="dainik-content">
        <Zodiac/>
           <div className="controls">
                <div className="mode-toggle">
                  <button onClick={() => setTimeFormat("12")} className={timeFormat === "12" ? "active" : ""}>12 Hour</button>
                  <button onClick={() => setTimeFormat("24")} className={timeFormat === "24" ? "active" : ""}>24 Hour</button>
                  <button onClick={() => setTimeFormat("24Plus")} className={timeFormat === "24Plus" ? "active" : ""}>24 Plus</button>
                </div>

                <div className="month-grid">
                  {months.map((month, i) => (
                    <button key={i} onClick={() => handleMonthClick(i)}>{month}</button>
                  ))}
                </div>

                <div className="day-grid">
                  {Array.from({ length: 31 }, (_, i) => (
                    <button key={i} onClick={() => handleDayClick(i + 1)}>{i + 1}</button>
                  ))}
                </div>

                 <div className="location-date">
                  <div className="input-with-icon">
                  <span className="icon">📍</span>
                  <input
                    type="text"
                    value={tempLocation}
                    onChange={handleChange}
                    placeholder="Enter location"
                  />
                  {suggestions.length > 0 && (
                    <ul className="dropdown">
                      {suggestions.map((c, idx) => (
                        <li key={idx} onClick={() => handleSelect(c.city)}>
                          {c.city}, {c.state}, {c.country}
                        </li>
                      ))}
                    </ul>
                  )}
                  </div>
                  <input
                    type="date"
                    value={tempDate.toISOString().split("T")[0]}
                    onChange={handleDateInput}
                  />
                  <button onClick={handlePrevDay}>Prev Day</button>
                  <button onClick={handleNextDay}>Next Day</button>
                  <button onClick={handleSubmit}>Submit</button>

                </div>
              </div>

               <div className="dainik-data">
                <h2>Sunrise and Moonrise</h2>
                  <div className="suntable">
                    <div className="suntable left">
                      {sunTable.slice(0, 2).map((item, i) => (
                        <div key={i} className="cell">
                          <h3>{item.name}</h3>
                          <p>{item.info}</p>
                        </div>
                      ))}
                    </div>

                    <div className="suntable right">
                      {sunTable.slice(2).map((item, i) => (
                        <div key={i} className="cell">
                          <h3>{item.name}</h3>
                          <p>{item.info}</p>
                        </div>
                      ))}
                    </div>
                  </div>
                   <h2>Panchang</h2>
                  <div className="panchang-table">
                    <div className="panchang-table left">
                      {panchangLeft.map((item, i) => (
                        <div key={i} className="cell">
                          <h3>{item.name}</h3>
                          <p>{item.info}</p>
                        </div>
                      ))}
                    </div>

                    <div className="panchang-table right">
                      {panchangRight.map((item, i) => (
                        <div key={i} className="cell">
                          <h3>{item.name}</h3>
                          <p>{item.info}</p>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>

      </div>
      <Footer/>
    </div>
  )
}

export default Dainik;
